import React, { useEffect, useRef } from "react";
import { Select } from "antd";

export const ConceptsSelector = ({
                                     size = "small",
                                     width = 150,
                                     selectedLocalConcepts = [],
                                     setSelectedLocalConcepts,
                                     localConceptOptions = [],
                                     setConceptList,
                                     deselect = false,
                                     setDeselectionConcepts,
                                     ...props
                                 }) => {
    const prevSelectedConceptsRef = useRef([]);

    useEffect(() => {
        prevSelectedConceptsRef.current = selectedLocalConcepts;
    }, [selectedLocalConcepts]);

    const handleConceptChange = (newSelectedConcepts) => {
        const previousSelectedConcepts = prevSelectedConceptsRef.current || [];
        if (deselect) {
            const deselectedConcepts = previousSelectedConcepts.filter(
                (concept) => !newSelectedConcepts.includes(concept)
            );
            setDeselectionConcepts(deselectedConcepts);
        }

        setSelectedLocalConcepts(newSelectedConcepts);
    };

    return (
        <Select
            {...props}
            mode="multiple"
            data-testid="conceptsSelector"
            allowClear
            showSearch
            style={{ width }}
            placeholder="Select Concept"
            value={selectedLocalConcepts}
            onChange={handleConceptChange}
            options={localConceptOptions.map((option) => ({
                label: option.name,
                value: option.name,
            }))}
            fieldNames={{
                label: "label",
                value: "value",
            }}
            size={size}
            maxTagTextLength={20}
            maxTagCount="responsive"
        />
    );
};
